export default function PageHeader({ overline, title, subtitle, children }) {
  return (
    <section className="border-b border-black/10 bg-white">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28">
        {overline && <span className="text-[11px] uppercase tracking-[0.2em] text-zinc-400">{overline}</span>}
        <h1 className="mt-3 font-display text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter max-w-4xl leading-[0.95]">{title}</h1>
        {subtitle && <p className="mt-6 text-lg sm:text-xl text-zinc-600 max-w-2xl leading-relaxed">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}
